// @ts-check
/**
 * @typedef {import('./strategies/AdyenApplePayStrategy').AdyenApplePayStrategy} AdyenApplePayStrategy
 * @typedef {import('./strategies/StripeApplePayStrategy').StripeApplePayStrategy} StripeApplePayStrategy
 */

/**
 * ApplePay Payment Method
 * @function ApplePay
 */
const ApplePay = () => {
  /**
   * @type {AdyenApplePayStrategy | StripeApplePayStrategy | undefined}
   */
  let strategy;

  /**
   * Set the strategy
   * @param {AdyenApplePayStrategy | StripeApplePayStrategy} newStrategy
   * @returns {void}
   */
  const setStrategy = (newStrategy) => {
    strategy = newStrategy;
  };

  /**
   * Create a payload for Apple Pay.
   * @param {Object} data - The Apple Pay data from onSubmit callback.
   * @param {Object} [enginePayload] - Engine-specific payload (e.g. Stripe's
   *   `{ stripeConfirmationToken }`). Strategies that don't need it ignore it.
   * @returns {Promise<Object>} The payload.
   */
  const createPayload = (data, enginePayload = {}) => {
    if (!strategy) {
      throw new Error('Apple Pay strategy not set');
    }

    return strategy.createPayload(data, enginePayload);
  };

  return {
    setStrategy,
    createPayload,
  };
};

const applePay = ApplePay();

export default applePay;
